export const viewportSize = () => {
  const coords = {
    width: window.innerWidth,
    height: window.innerHeight,
    ratio: window.innerWidth / window.innerHeight,
  };

  return coords;
};

export const getCurrentRotation = (el) => {
  var st = window.getComputedStyle(el, null);
  var tr = st.getPropertyValue("-webkit-transform") ||
    st.getPropertyValue("-moz-transform") ||
    st.getPropertyValue("-ms-transform") ||
    st.getPropertyValue("-o-transform") ||
    st.getPropertyValue("transform") ||
    "fail...";
    
  if (tr !== "none") {
    var values = tr.split('(')[1];
    values = values.split(')')[0];
    values = values.split(',');
    var a = values[0];
    var b = values[1];
    var radians = Math.atan2(b, a);
    var angle = Math.round(radians * (180 / Math.PI));
  } else {
    var angle = 0;
  }

  return angle;
}

export const getCurrentTranslate = (element) => {
  const transformValue = window.getComputedStyle(element).transform;
  const w = window.getComputedStyle(element).width;
  const h = window.getComputedStyle(element).height;
  var matrix = new WebKitCSSMatrix(transformValue);
  return {
    x: parseInt(matrix.m41 / parseInt(w) * 100),
    y: parseInt(matrix.m42 / parseInt(h) * 100)
  };
}

export const getCurrentScale = (element) => {
  const transformValue = window.getComputedStyle(element).transform;
  var matrix = new WebKitCSSMatrix(transformValue);
  return parseFloat(Math.sqrt(matrix.a * matrix.a + matrix.b * matrix.b).toFixed(2));
}